import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers"
import ACTIONS from "./ActionTypes"

const initialState = {
    _isFetching: false,
    _isPatching: false,
    _forceFetch: true,
    ids: [],
    entities: {},
    byEntityId: {}
}

const settingsEntityTypesReducer = (
    state = initialState,
    { payload, type }: any
) => {
    switch (type) {
        case getActionType(ACTIONS.FETCH_ENTITY_TYPES).REQUEST: {
            return {
                ...state,
                _isFetching: true,
                _forceFetch: false
            }
        }

        case getActionType(ACTIONS.PATCH_ENTITY_TYPES).REQUEST: {
            return {
                ...state,
                _isPatching: true
            }
        }

        case getActionType(ACTIONS.FETCH_ENTITY_TYPES).SUCCESS: {
            const { data } = payload;
            
            if (data?.length <= 0) return state;

            const ids: any = data.map(({id}) => id);
            const entities: any = convertArrayToObject(data, 'id');

            let byEntityId = data.reduce(
                (acc, curr) => 
                    acc = {
                        ...acc,
                        [curr.entity_id]: [
                            ...(acc?.[curr.entity_id] ?? []),
                            curr.id
                        ]
                    },
                {}
            )
            
            return {
                ...state,
                _isFetching: false,
                ids: new Set([...state.ids, ids]),
                entities: {
                    ...state.entities,
                    ...entities
                },
                byEntityId
            }
        }

        case getActionType(ACTIONS.PATCH_ENTITY_TYPES).SUCCESS: {
            const { data } = payload;

            return {
                ...state,
                _isPatching: false,
                entities: {
                    ...state.entities,
                    [data.id]: data
                }
            }
        }

        default:
            return state;
    }
}

export default settingsEntityTypesReducer;